import { downloadFile } from 'helpers/downloadFile'
import Icon from 'ui/components/Icon'
import { File, FileTitle, FileDelete } from './styled'

const FileChip = ({
  title,
  canDelete = false,
  link,
  fileId,
  deleteHandler,
}) => {
  const handleDownload = async (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (!link) return

    await downloadFile(title, link)
  }

  return (
    <File onClick={handleDownload}>
      <FileTitle>{title}</FileTitle>

      {canDelete && (
        <FileDelete
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            deleteHandler(fileId)
          }}
        >
          <Icon name="close" />
        </FileDelete>
      )}
    </File>
  )
}

export default FileChip
